import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import AlurPeminjaman from "../Component/AlurPeminjaman";
import KeuntunganBermitra from "../Component/KeuntunganBermitra";
import AllProductIndividu from "../Component/AllProductIndividu";

function PinjamanIndividu() {
    return (
        <>
            <div>
                <Hero
                    imageClass='ebp'
                    title='<em>Employee Benefit Program</em>'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='
                        Fasilitas ini diberikan kepada perusahaan yang terkendala <em>Cash Flow</em> dalam memberikan program kesejahteraan karyawan.<br/><br/>Dengan bermitra dengan Danai.id, perusahaan dapat memiliki program/ fasilitas kesejahteraan karyawan sehingga hal ini dapat menjadi nilai tambah bagi perusahaan ketika melakukan proses rekrutmen dan dapat mempertahankan karyawan terbaiknya.'
                />
                <KeuntunganBermitra/>
                <AllProductIndividu/>
                <AlurPeminjaman type='individu'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default PinjamanIndividu;
